export default "__VITE_ASSET__5c5c16ec__"